import ToggleTemplate from '../../html/components/toggle.html'
import ToggleListTemplate from '../../html/components/toggle-list.html'

import Component from '../shared/component'
import Relation, {HasMany, MemberOf} from '../shared/mixins/relation'

import {InteractiveMixin} from './interactive'

const toggleList = Relation()

export const Toggle = Component('v-toggle', {
  mixins: [
    MemberOf(toggleList, 'list'),
    InteractiveMixin
  ],
  template: ToggleTemplate,
  props: {
    value: {
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      validator (value) {
        switch (value) {
          case '':
          case 'small':
            return true
          default:
            return false
        }
      }
    }
  },
  data () {
    return {
      active: this.selected
    }
  },
  computed: {
    variantClass () {
      return this.variant && `is-${this.variant}`
    },

    buttonVariant () {
      switch (this.variant) {
        case 'small':
          return 'outline'
      }
    },

    group () {
      const {list} = this

      if (list) {
        return list.group
      }
    }
  },
  watch: {
    active () {
      this.$emit('change', this.active)
    },

    selected () {
      this.active = this.selected
    }
  },
  methods: {
    select () {
      if (!this.active) {
        this.active = true
      }
    },

    deselect () {
      if (this.active) {
        this.active = false
      }
    }
  }
})

export const ToggleList = Component('v-toggle-list', {
  model: {
    prop: 'value',
    event: 'change'
  },
  mixins: [
    HasMany(toggleList, 'toggles')
  ],
  template: ToggleListTemplate,
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      active: null
    }
  },
  computed: {
    group () {
      return this.$children[0]
    }
  },
  watch: {
    active (_, previous) {
      if (previous) {
        previous.deselect()
      }

      this.active.select()

      this.$emit('change', this.active.value)
    },

    value () {
      this.toggles.forEach(toggle => {
        if (toggle.value !== null && this.value === toggle.value) {
          this.select(toggle)
        }
      })
    },

    toggles () {
      this.toggles.forEach(toggle => {
        if (!this.active) {
          if ((toggle.value !== null && this.value === toggle.value) || (this.value === null && toggle.active)) {
            this.select(toggle)
          }
        }

        if (this.active === toggle) {
          toggle.select()
        } else {
          toggle.deselect()
        }

        toggle.$on('change', active => active
          ? this.select(toggle)
          : null
        )
      })
    }
  },
  methods: {
    select (toggle) {
      this.active = toggle
    }
  }
})
